import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { LayoutServiceService } from 'src/app/services/layout-service.service';
import { HomeService } from 'src/app/home/Services/home.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'ico-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent {

  title = 'iconicangular';
  public isStopLoading: boolean = true;
  public showNotifMenu: boolean = false;
  public showToggleMenu: boolean = false;
  public navTab: string = 'menu';
  public currentActiveMenu = 'light';
  public currentActiveSubMenu;
  public currentActiveSubOfSub;
  public themeClass: string = 'theme-cyan';
  public themeDarkClass: string = 'light';
  public themeHighContClass: string = '';
  public smallScreenMenu = '';
  public darkClass: string = '';
  private ngUnsubscribe = new Subject();
  public rtlClass: string = '';
  public themeFontClass: string = 'font-nunito';
  public isHorizontalMenu: boolean = false;
  isRightToggle: string;
  isPrintPage: boolean = false;
  themeSettings:any = [];
  imageBaseUrl:string = environment.image_base_url;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private layoutServiceService: LayoutServiceService,
    private homeservice: HomeService
  ) {
    this.router.events
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.isStopLoading = false;
          this.getActiveRoutes();
        }
      });

    this.layoutServiceService.isHorizontalMenuSubject
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((isHorizontalMenu) => {
        this.isHorizontalMenu = isHorizontalMenu;
        if (isHorizontalMenu) {
          this.document.body.classList.add('h_menu');
        } else {
          this.document.body.classList.remove('h_menu');
        }
        this.cdr.detectChanges();
      });

    this.layoutServiceService.themeClassChange
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((themeClass) => {
        this.themeClass = themeClass;
      });

    this.layoutServiceService.themeDarkClassChange
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((themeDarkClass) => {
        this.themeDarkClass = themeDarkClass;
      });

    this.layoutServiceService.rtlClassChange
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((rtlClass) => {
        this.rtlClass = rtlClass;
      });

    this.layoutServiceService.themeHighConChange
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((highContClass) => {
        this.themeHighContClass = highContClass;
      });

    this.layoutServiceService.themeFontFamilyChange
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((fontClass) => {
        this.themeFontClass = fontClass;
      });

    this.layoutServiceService.rightBarToggleChange
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((rightToggle) => {
        if (rightToggle === 'right_icon_toggle') {
          this.document.body.classList.add('right_icon_toggle');
        } else {
          this.document.body.classList.remove('right_icon_toggle');
        }
      });
  }

  ngOnInit(): void {
    let themeSettingsData = JSON.parse(localStorage.getItem('ThemeSettings'));
    if(themeSettingsData){
      let logoElements = document.getElementsByClassName('web-app-logo');
      jQuery('#appFavicon').attr('href',this.imageBaseUrl + themeSettingsData.favicon);
      for(var i=0; i<logoElements.length; i++){
        logoElements[i].setAttribute('src',this.imageBaseUrl + themeSettingsData.logo)
      }
    }else{
      this.homeservice.getThemeSettings().subscribe((data: any) => {
        this.themeSettings = data.data || [];
        localStorage.setItem('ThemeSettings',JSON.stringify(this.themeSettings[0]));
        let logoElements = jQuery('.web-app-logo');
        jQuery('#appFavicon').attr('href',this.imageBaseUrl + this.themeSettings[0].favicon);
        for(var i=0; i<logoElements.length; i++){
          logoElements[i].setAttribute('src',this.imageBaseUrl + this.themeSettings[0].logo)
        }
      }, (errorData: any) => {
        var error = errorData;
        if (error.status == 401) {
          this.router.navigate(["/authentication/login"]);
        }
      });
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  getActiveRoutes() {
    let segments: Array<string> = this.router.url.split('/');
    this.currentActiveMenu = segments[1];
    this.currentActiveSubMenu = segments[2];
    this.currentActiveSubOfSub = segments[3];
    if (this.currentActiveSubOfSub?.includes('print') || this.currentActiveSubMenu?.includes('print')) {
      this.isPrintPage = true;
    } else if ((this.currentActiveSubMenu == 'usage-report' || this.currentActiveSubMenu == 'user-usage-report') && this.currentActiveSubOfSub == 'view') {
      this.isPrintPage = true;
    } else {
      this.isPrintPage = false;
    }
  }
}
